/**
 * Checks if current page is in iframe
 */
export var isInIframe = function () { return window.parent !== window; };
